import { render } from "./AllCountries.vue?vue&type=template&id=0b670028"
import script from "./AllCountries.vue?vue&type=script&lang=js"
export * from "./AllCountries.vue?vue&type=script&lang=js"

import "./AllCountries.vue?vue&type=style&index=0&id=0b670028&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__